$(document).ready(function(){

  $(document).on("change",".recommend-variant select",function(){
    var opt = $(this).val();
    var price = $(this).find("option[value='"+opt+"']").attr("data-price");
    var comparePrice = $(this).find("option[value='"+opt+"']").attr("data-compare");
    var soldout = $(this).find("option[value='"+opt+"']").attr("data-soldout");
    var img = $(this).find("option[value='"+opt+"']").attr("data-img");
    if(soldout == 'true')
    {
      $(".recommend-atc span").text("Sold out");
      $(".recommend-atc").addClass("disabled");
    }
    else
    {
      $(".recommend-atc span").text("Mitbestellen");
      $(".recommend-atc").removeClass("disabled");
    }
    if(img != '')
    {
      $(".recommend-img").find("img").attr("src",img);
    }
    $(".recommend-actual-price").html(price);
    $(".recommend-compare-price").html(comparePrice);
  });

  
  $(document).on("click",".recommend-atc",function(){
    $(this).addClass("disabled");
    var l1 = $(".recommend-variant select").length;
    if(l1 != 0)
    {
      var id = $(".recommend-variant select").val();
    }
    else
    {
      var id = $(".recommend-variant input").val();
    }
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: "quantity=1&id="+id,
      success: function(data){
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data
          }
        }));
      }
   });
  });
  
  setInterval(function(){
    console.log("checking unnecessary quantity inputs!");
    if($("#gafqtyselecter").length != 0)
    {
      $("#gafqtyselecter").remove();
    }
  },1000);
  
});